import { HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { BitsApis } from "@app/core/APIs/bits-apis";
import { CrudApiOptions, CrudApiService, GenResp } from "@ez-library/services/crud-api.service";
import { Observable, map } from "rxjs";
import {
    PhmsIntakeSubmissionCreateRequest,
    PhmsIntakeSubmissionDto,
    PhmsIntakeSubmissionListQuery,
    PhmsIntakeSubmissionListResult,
} from "./phms-manual-intake-submission.models";

const requestHeaders = new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "application/json, text/plain, */*",
    "skip-error-interceptor": "yes",
    "skip-loading-interceptor": "yes",
});

const intakeApiOptions: Partial<CrudApiOptions<"body", "json">> = {
    retries: 0,
    feedbackOptions: { successMode: "none", errorMode: "none" },
    getOptions: { responseType: "json", headers: requestHeaders, withCredentials: true },
    postOptions: { responseType: "json", headers: requestHeaders, withCredentials: true },
};

@Injectable({ providedIn: "root" })
export class PhmsManualIntakeSubmissionService {
    private readonly bitsApis = inject(BitsApis);
    private readonly crudService = inject(CrudApiService);

    createIntake(request: PhmsIntakeSubmissionCreateRequest): Observable<PhmsIntakeSubmissionDto> {
        return this.crudService
            .postByUrl<PhmsIntakeSubmissionDto>(
                this.bitsApis.core.manual.postPhmsIntakeSubmission(),
                buildIntakePayload(request),
                intakeApiOptions,
            )
            .pipe(map((response) => unwrapResponse(response)));
    }

    getById(id: number): Observable<PhmsIntakeSubmissionDto> {
        return this.crudService
            .getbyUrl<PhmsIntakeSubmissionDto>(
                this.bitsApis.core.manual.getPhmsIntakeSubmission(id),
                intakeApiOptions,
            )
            .pipe(map((response) => unwrapResponse(response)));
    }

    list(query?: PhmsIntakeSubmissionListQuery): Observable<PhmsIntakeSubmissionListResult> {
        return this.crudService
            .getbyUrl<PhmsIntakeSubmissionListResult>(
                this.bitsApis.core.manual.getPhmsIntakeSubmissionList(query),
                intakeApiOptions,
            )
            .pipe(map((response) => unwrapResponse(response)));
    }
}

function buildIntakePayload(request: PhmsIntakeSubmissionCreateRequest): PhmsIntakeSubmissionCreateRequest {
    return {
        incarceratedPersonDisplayName: request.incarceratedPersonDisplayName.trim(),
        incarceratedPersonIdentifier: request.incarceratedPersonIdentifier.trim(),
        programScopeKey: request.programScopeKey.trim(),
    };
}

function unwrapResponse<T>(response: GenResp<T> | T | undefined | null): T {
    if (response && typeof response === "object" && "data" in response) {
        return (response as GenResp<T>).data;
    }

    return response as T;
}

